/*eslint no-unused-vars: "error"*/
import * as accesslogOptions from './options/accesslog';
import * as companyOptions from './options/company';
import * as domainOptions from './options/domain';
import * as eventlogOptions from './options/eventlog';
import * as fabricOptions from './options/fabric';
import * as fabricOrderLineOptions from './options/fabricOrderLine';
import * as fabricOrderOptions from './options/fabricOrder';
import * as glAccountOptions from './options/glAccount';
import * as invoiceSummaryOptions from './options/invoiceSummary.js';
import * as internalInvoiceOptions from './options/internalInvoice';
import * as linkDomainProductGroupOptions from './options/linkDomainProductGroup';
import * as linkDomainProductGroupFinishOptions from './options/linkDomainProductGroupFinish';
import * as optionOptions from './options/option';
import * as orderOptions from './options/order';
import * as orderLineOptions from './options/orderline';
import * as parcelTypeOptions from './options/parcelType';
import * as permissionOptions from './options/permission';
import * as printTemplateOptions from './options/printTemplate';
import * as productGroupOptions from './options/productgroup';
import * as hemaPendingProjectOptions from './options/hemaPendingProject';
import * as roleOptions from './options/role';
import * as storeOptions from './options/store';
import * as standardUserOptions from './options/standardUser';
import * as stockCorrectionOptions from './options/stockcorrection';
import * as storeUserOptions from './options/storeUser';
import * as templateImageOptions from './options/templateImage';
import * as workshopOptions from './options/workshop';
import * as configurationOptions from './options/configuration';
import * as productionPlanningOptions from './options/productionPlanning';
import * as finishOptions from './options/finish';
import * as finishTypeOptions from './options/finishtype';
import * as productionPlanningSelectionOptions from './options/productionPlanningSelection';
import * as productionPlanningSeriesOptions from './options/productionPlanningSeries';
import * as fabricStockReportOptions from './options/fabricStockReport';
import * as transportOrderOptions from './options/transportOrder';
import * as priceListItemOptions from './options/priceListItem';
import * as vatTypeRateOptions from './options/vatTypeRateOptions';
import * as externalInvoiceOptions from './options/externalInvoice';
import * as orderLineStatusOptions from './options/orderlinestatus';
import * as reportOptions from './options/reports';
import * as printerClientOptions from './options/printerClient';
import * as storeOrderLineOptions from './options/storeOrderLine';
import * as storeOrderLineShipmentOptions from './options/storeOrderLineShipment';
import * as orderPickListOptions from './options/orderpicklist';
import * as interiorDecoratorOrderOptions from './options/interiorDecoratorOrder';
// PLOP: Import option files
// eslint-disable-next-line
import { RouteParent, CrudStore } from './interfaces';

const Security = {
  name: 'Security',
  srcPath: '@/pages/admin/security/',
  i18nTitlePrefix: 'menu_security_'
} as RouteParent;

const Application = {
  name: 'Application',
  srcPath: '@/pages/admin/application/',
  i18nTitlePrefix: 'menu_application_'
} as RouteParent;

const Company = {
  name: 'Company',
  srcPath: '@/pages/admin/company/',
  i18nTitlePrefix: 'menu_company_'
} as RouteParent;

const routeParentPages = {
  Security,
  Application,
  Company
};

export const routerPages = {};
Object.keys(routeParentPages).forEach(key => {
  routerPages[routeParentPages[key].name] = [];
});

const accesslog = {
  permissionName: 'Accesslog',
  requestUrl: '/accesslog',
  store: 'accesslog',
  backendEntityIDField: 'accessLogID',
  options: accesslogOptions
} as CrudStore;

const appSetting = {
  permissionName: 'AppSetting',
  requestUrl: '/app-settings',
  store: 'appSetting',
  backendEntityIDField: 'appSettingID'
} as CrudStore;

const ban = {
  permissionName: 'Ban',
  requestUrl: '/ban',
  store: 'ban',
  backendEntityIDField: 'id'
} as CrudStore;

const client = {
  permissionName: 'Client',
  requestUrl: '/client',
  store: 'client',
  backendEntityIDField: 'clientID'
} as CrudStore;

const collection = {
  permissionName: 'Collection',
  requestUrl: '/collection',
  store: 'collection',
  backendEntityIDField: 'collectionID'
} as CrudStore;

const company = {
  permissionName: 'Company',
  requestUrl: '/company',
  store: 'company',
  backendEntityIDField: 'companyID',
  options: companyOptions
} as CrudStore;

const configuration = {
  permissionName: 'Configuration',
  requestUrl: '/configuration',
  store: 'configuration',
  backendEntityIDField: 'configurationID',
  options: configurationOptions
} as CrudStore;

const contactPerson = {
  permissionName: 'ContactPerson',
  requestUrl: '/contactperson',
  store: 'contactPerson',
  backendEntityIDField: 'contactPersonID'
} as CrudStore;

const country = {
  permissionName: 'Country',
  requestUrl: '/country',
  store: 'country',
  backendEntityIDField: 'countryID'
} as CrudStore;

const domain = {
  permissionName: 'Domain',
  requestUrl: '/domain',
  store: 'domain',
  backendEntityIDField: 'domainID',
  options: domainOptions
} as CrudStore;

const domainUser = {
  permissionName: 'DomainUser',
  requestUrl: '/domain-user',
  store: 'domainUser',
  backendEntityIDField: 'userID'
} as CrudStore;

const eventlog = {
  permissionName: 'Eventlog',
  requestUrl: '/eventlog',
  store: 'eventlog',
  backendEntityIDField: 'eventLogID',
  options: eventlogOptions
} as CrudStore;

const exactInstance = {
  permissionName: 'ExactInstance',
  requestUrl: '/exact-instance',
  store: 'exactInstance',
  backendEntityIDField: 'exactInstanceID'
} as CrudStore;

const externalApiUser = {
  permissionName: 'ExternalApiUser',
  requestUrl: '/externalApiUser',
  store: 'externalApiUser',
  backendEntityIDField: 'externalApiUserID'
} as CrudStore;

const externalInvoice = {
  permissionName: 'ExternalInvoice',
  requestUrl: '/external-invoice',
  store: 'externalInvoice',
  backendEntityIDField: 'externalInvoiceID',
  options: externalInvoiceOptions
} as CrudStore;

const fabric = {
  permissionName: 'Fabric',
  requestUrl: '/fabric',
  store: 'fabric',
  backendEntityIDField: 'productID',
  options: fabricOptions
} as CrudStore;

const fabricOrder = {
  permissionName: 'FabricOrder',
  requestUrl: '/fabricorder',
  store: 'fabricOrder',
  backendEntityIDField: 'fabricOrderID',
  options: fabricOrderOptions
} as CrudStore;

const fabricOrderLine = {
  permissionName: 'FabricOrder',
  requestUrl: '/fabricorderline',
  store: 'fabricOrderLine',
  backendEntityIDField: 'fabricOrderLineID',
  options: fabricOrderLineOptions
} as CrudStore;

const fabricStockReport = {
  permissionName: 'FabricStockReport',
  requestUrl: '/fabricstockreport',
  store: 'fabricStockReport',
  backendEntityIDField: 'id',
  options: fabricStockReportOptions
} as CrudStore;

const finish = {
  permissionName: 'Finish',
  requestUrl: '/finish',
  store: 'finish',
  backendEntityIDField: 'finishID',
  options: finishOptions
} as CrudStore;

const finishType = {
  permissionName: 'FinishType',
  requestUrl: '/finishtype',
  store: 'finishType',
  backendEntityIDField: 'finishTypeID',
  options: finishTypeOptions
} as CrudStore;

const hemaPendingProject = {
  permissionName: 'HemaPendingProject',
  requestUrl: '/hema-pending-project',
  store: 'hemaPendingProject',
  backendEntityIDField: 'id',
  options: hemaPendingProjectOptions
} as CrudStore;

const interiorDecoratorFabric = {
  permissionName: 'InteriorDecoratorOrder',
  requestUrl: '/interior-decorator/fabric',
  store: 'interiorDecoratorFabric',
  backendEntityIDField: 'productID'
} as CrudStore;

const interiorDecoratorOrder = {
  permissionName: 'InteriorDecoratorOrder',
  requestUrl: '/interior-decorator-order',
  store: 'interiorDecoratorOrder',
  options: interiorDecoratorOrderOptions
} as CrudStore;

const internalInvoice = {
  permissionName: 'InternalInvoice',
  requestUrl: '/internal-invoice',
  store: 'internalInvoice',
  backendEntityIDField: 'internalInvoiceID',
  options: internalInvoiceOptions
} as CrudStore;

const invalidFinishCombination = {
  permissionName: 'InvalidFinishCombination',
  requestUrl: '/invalid-finish-combination',
  store: 'invalidFinishCombination',
  backendEntityIDField: 'invalidFinishCombinationID'
} as CrudStore;

const language = {
  permissionName: 'Language',
  requestUrl: '/language',
  store: 'language',
  backendEntityIDField: 'languageID'
} as CrudStore;

const linkStoreCollection = {
  requestUrl: '/link-store-collection',
  store: 'linkStoreCollection',
  backendEntityIDField: 'linkStoreCollectionID'
} as CrudStore;

const linkDomainProductGroup = {
  permissionName: 'Domain',
  requestUrl: '/linkdomainproductgroup',
  store: 'linkDomainProductGroup',
  backendEntityIDField: 'linkDomainProductGroupID',
  options: linkDomainProductGroupOptions
} as CrudStore;

const linkDomainProductGroupFinish = {
  permissionName: 'Domain',
  requestUrl: '/linkdomainproductgroupfinish',
  store: 'linkDomainProductGroupFinish',
  backendEntityIDField: 'linkDomainProductGroupFinishID',
  options: linkDomainProductGroupFinishOptions
} as CrudStore;

const option = {
  permissionName: 'Option',
  requestUrl: '/option',
  store: 'option',
  backendEntityIDField: 'optionID',
  options: optionOptions
} as CrudStore;

const order = {
  permissionName: 'Order',
  requestUrl: '/order',
  store: 'order',
  backendEntityIDField: 'orderID',
  options: orderOptions
} as CrudStore;

const orderDraft = {
  permissionName: 'OrderDraft',
  requestUrl: '/order-draft',
  store: 'orderDraft',
  backendEntityIDField: 'orderNumber'
} as CrudStore;

const orderLine = {
  permissionName: 'Order',
  requestUrl: '/orderline',
  store: 'orderLine',
  backendEntityIDField: 'orderLineID',
  options: orderLineOptions
} as CrudStore;

const penalty = {
  permissionName: 'Ban',
  requestUrl: '/penalty',
  store: 'penalty',
  backendEntityIDField: 'id'
} as CrudStore;

const storeUser = {
  permissionName: 'StoreUser',
  requestUrl: '/storeUser',
  store: 'storeUser',
  backendEntityIDField: 'userID',
  options: storeUserOptions
} as CrudStore;

const interiorDecorator = {
  permissionName: 'InteriorDecorator',
  requestUrl: '/interior-decorator',
  store: 'interiorDecorator',
  backendEntityIDField: 'userID'
} as CrudStore;

const storeFabric = {
  permissionName: 'StoreUser',
  requestUrl: '/storeFabric',
  store: 'storeFabric',
  backendEntityIDField: 'id'
} as CrudStore;

const permission = {
  permissionName: 'Permission',
  requestUrl: '/permission',
  store: 'permission',
  backendEntityIDField: 'permissionID',
  options: permissionOptions
} as CrudStore;

const printer = {
  permissionName: 'Printer',
  requestUrl: '/printer',
  store: 'printer',
  backendEntityIDField: 'printerID'
} as CrudStore;

const printTemplate = {
  permissionName: 'PrintTemplate',
  requestUrl: '/printtemplate',
  store: 'printTemplate',
  backendEntityIDField: 'printTemplateID',
  options: printTemplateOptions
} as CrudStore;

const special = {
  permissionName: 'Special',
  requestUrl: '/special',
  store: 'special',
  backendEntityIDField: 'specialID'
} as CrudStore;

const templateImage = {
  permissionName: 'TemplateImage',
  requestUrl: '/templateimage',
  store: 'templateImage',
  backendEntityIDField: 'templateImageID',
  options: templateImageOptions
} as CrudStore;

const product = {
  permissionName: 'Product',
  requestUrl: '/product',
  store: 'product',
  backendEntityIDField: 'productID'
} as CrudStore;

const productGroup = {
  permissionName: 'ProductGroup',
  requestUrl: '/productgroup',
  store: 'productGroup',
  backendEntityIDField: 'productGroupID',
  options: productGroupOptions
} as CrudStore;

const productType = {
  permissionName: 'ProductType',
  requestUrl: '/producttype',
  store: 'productType',
  backendEntityIDField: 'productTypeID'
} as CrudStore;

const productionPlanning = {
  permissionName: 'ProductionPlanning',
  requestUrl: '/production-planning',
  store: 'productionPlanning',
  backendEntityIDField: 'productionPlanningID',
  options: productionPlanningOptions
} as CrudStore;

const productionPlanningSelection = {
  permissionName: 'ProductionPlanningSelection',
  requestUrl: '/productionplanningselection',
  store: 'productionPlanningSelection',
  options: productionPlanningSelectionOptions
} as CrudStore;

const productionPlanningSeries = {
  permissionName: 'ProductionPlanningSeries',
  requestUrl: '/productionplanningseries',
  store: 'productionPlanningSeries',
  backendEntityIDField: 'productionPlanningSeriesID',
  options: productionPlanningSeriesOptions
} as CrudStore;

const reasonStockCorrection = {
  permissionName: 'ReasonStockCorrection',
  requestUrl: '/reasonstockcorrection',
  store: 'reasonStockCorrection',
  backendEntityIDField: 'reasonStockCorrectionID'
} as CrudStore;

const role = {
  permissionName: 'Role',
  requestUrl: '/role',
  store: 'role',
  backendEntityIDField: 'roleID',
  options: roleOptions
} as CrudStore;

const store = {
  permissionName: 'Store',
  requestUrl: '/store',
  store: 'store',
  backendEntityIDField: 'storeID',
  options: storeOptions
} as CrudStore;

const storeAttribute = {
  permissionName: 'StoreAttribute',
  requestUrl: '/store-attribute',
  store: 'storeAttribute',
  backendEntityIDField: 'storeAttributeID'
} as CrudStore;

const stockCorrection = {
  permissionName: 'StockCorrection',
  requestUrl: '/stockcorrection',
  store: 'stockCorrection',
  backendEntityIDField: 'stockCorrectionID',
  options: stockCorrectionOptions
} as CrudStore;

const stock = {
  permissionName: 'Stock',
  requestUrl: '/stock',
  store: 'stock',
  backendEntityIDField: 'stockID'
} as CrudStore;

const supplier = {
  permissionName: 'Supplier',
  requestUrl: '/supplier',
  store: 'supplier',
  backendEntityIDField: 'supplierID'
} as CrudStore;

const stockLocation = {
  permissionName: 'StockLocation',
  requestUrl: '/stocklocation',
  store: 'stockLocation',
  backendEntityIDField: 'stockLocationID'
} as CrudStore;

const translation = {
  permissionName: 'Translation',
  requestUrl: '/string-description',
  store: 'translation',
  backendEntityIDField: 'stringDescriptionID'
} as CrudStore;

const unit = {
  permissionName: 'Unit',
  requestUrl: '/unit',
  store: 'unit',
  backendEntityIDField: 'unitID'
} as CrudStore;

const standardUser = {
  permissionName: 'StandardUser',
  requestUrl: '/standardUser',
  store: 'standardUser',
  backendEntityIDField: 'userID',
  options: standardUserOptions,
  route: {
    parent: Security,
    listViewName: 'StandardUsers'
  }
} as CrudStore;

const vatType = {
  permissionName: 'VatType',
  requestUrl: '/vattype',
  store: 'vatType',
  backendEntityIDField: 'vatTypeID'
} as CrudStore;

const vatTypeRate = {
  permissionName: 'VatType',
  requestUrl: '/vattype-rate',
  store: 'vatTypeRate',
  backendEntityIDField: 'vatTypeRateID',
  options: vatTypeRateOptions
} as CrudStore;

const workshop = {
  permissionName: 'Workshop',
  requestUrl: '/workshop',
  store: 'workshop',
  backendEntityIDField: 'workshopID',
  options: workshopOptions
} as CrudStore;

const yarn = {
  permissionName: 'Yarn',
  requestUrl: '/yarn',
  store: 'yarn',
  backendEntityIDField: 'yarnID'
} as CrudStore;

const orderPickList = {
  permissionName: 'OrderPickList',
  requestUrl: '/orderpicklist',
  store: 'orderPickList',
  backendEntityIDField: 'id',
  options: orderPickListOptions
} as CrudStore;

// PLOP: Crud store modules
const queuedKwantumOrder = {
  permissionName: 'QueuedKwantumOrder',
  requestUrl: '/queued-kwantum-order',
  store: 'queuedKwantumOrder',
  backendEntityIDField: 'queuedKwantumOrderID'
} as CrudStore;

const printerClient = {
  permissionName: 'PrinterClient',
  requestUrl: '/printer-client',
  store: 'printerClient',
  backendEntityIDField: 'printerClientID',
  options: printerClientOptions
} as CrudStore;

const glAccount = {
  permissionName: 'GLAccount',
  requestUrl: '/general-ledger-account',
  store: 'glAccount',
  backendEntityIDField: 'glAccountID',
  options: glAccountOptions
} as CrudStore;

const linkDomainDeliveryPrice = {
  permissionName: 'LinkDomainDeliveryPrice',
  requestUrl: '/link-domain-delivery-price',
  store: 'linkDomainDeliveryPrice',
  backendEntityIDField: 'linkDomainDeliveryPriceID'
} as CrudStore;

const linkReasonStockCorrectionDomain = {
  permissionName: 'ReasonStockCorrection',
  requestUrl: '/link-reason-stock-correction-domain',
  store: 'linkReasonStockCorrectionDomain',
  backendEntityIDField: 'linkReasonStockCorrectionDomainID'
} as CrudStore;

const orderLinePrice = {
  permissionName: 'OrderLinePrice',
  requestUrl: '/order-line-price',
  store: 'orderLinePrice',
  backendEntityIDField: 'orderLinePriceID'
} as CrudStore;

const linkPriceListItem = {
  permissionName: 'LinkPriceListItem',
  requestUrl: '/link-price-list-item',
  store: 'linkPriceListItem',
  backendEntityIDField: 'linkPriceListItemID'
} as CrudStore;

const currency = {
  permissionName: 'Currency',
  requestUrl: '/currency',
  store: 'currency',
  backendEntityIDField: 'currencyID'
} as CrudStore;

const priceListItemPrice = {
  permissionName: 'PriceListItemPrice',
  requestUrl: '/price-list-item-price',
  store: 'priceListItemPrice',
  backendEntityIDField: 'priceListItemPriceID'
} as CrudStore;

const priceListMatrix = {
  permissionName: 'PriceListMatrix',
  requestUrl: '/price-list-matrix',
  store: 'priceListMatrix',
  backendEntityIDField: 'priceListMatrixID'
} as CrudStore;

const priceListItem = {
  permissionName: 'PriceListItem',
  requestUrl: '/price-list-item',
  store: 'priceListItem',
  backendEntityIDField: 'priceListItemID',
  options: priceListItemOptions
} as CrudStore;

const culture = {
  permissionName: 'Culture',
  requestUrl: '/culture',
  store: 'culture',
  backendEntityIDField: 'cultureID'
} as CrudStore;

const shipment = {
  permissionName: 'TransportOrder',
  requestUrl: '/shipment',
  store: 'shipment',
  backendEntityIDField: 'shipmentID'
} as CrudStore;

const shipmentListType = {
  permissionName: 'ShipmentListType',
  requestUrl: '/shipment-list-type',
  store: 'shipmentListType',
  backendEntityIDField: 'shipmentListTypeID'
} as CrudStore;

const storeType = {
  permissionName: 'StoreType',
  requestUrl: '/store-type',
  store: 'storeType',
  backendEntityIDField: 'storeTypeID'
} as CrudStore;

const returnCause = {
  permissionName: 'ReturnCause',
  requestUrl: '/return-cause',
  store: 'returnCause',
  backendEntityIDField: 'returnCauseID'
} as CrudStore;

const returnReasonCategory = {
  permissionName: 'ReturnReasonCategory',
  requestUrl: '/return-reason-category',
  store: 'returnReasonCategory',
  backendEntityIDField: 'returnReasonCategoryID'
} as CrudStore;

const returnReason = {
  permissionName: 'ReturnReason',
  requestUrl: '/return-reason',
  store: 'returnReason',
  backendEntityIDField: 'returnReasonID'
} as CrudStore;

const truck = {
  permissionName: 'Truck',
  requestUrl: '/truck',
  store: 'truck',
  backendEntityIDField: 'truckID'
} as CrudStore;

const parcelType = {
  permissionName: 'ParcelType',
  requestUrl: '/parcel-type',
  store: 'parcelType',
  backendEntityIDField: 'parcelTypeID',
  options: parcelTypeOptions
} as CrudStore;

const transportcompany = {
  permissionName: 'TransportCompany',
  requestUrl: '/transport-company',
  store: 'transportCompany',
  backendEntityIDField: 'transportCompanyID'
} as CrudStore;

const transportroute = {
  permissionName: 'TransportRoute',
  requestUrl: '/transport-route',
  store: 'transportRoute',
  backendEntityIDField: 'transportRouteID'
} as CrudStore;

const transportorder = {
  permissionName: 'TransportOrder',
  requestUrl: '/transport-order',
  store: 'transportOrder',
  backendEntityIDField: 'transportOrderID',
  options: transportOrderOptions
} as CrudStore;

const orderLineStatus = {
  permissionName: 'OrderLineStatus',
  requestUrl: '/order-line-status',
  store: 'orderLineStatus',
  options: orderLineStatusOptions,
  backendEntityIDField: 'orderLineStatusID'
} as CrudStore;

const storeOrderLine = {
  permissionName: 'StoreUser',
  requestUrl: '/storeOrderLine',
  store: 'storeOrderLine',
  options: storeOrderLineOptions,
  backendEntityIDField: 'ticketNumber'
} as CrudStore;

const storeOrderLineShipment = {
  permissionName: 'StoreUser',
  requestUrl: '/storeOrderLine',
  store: 'storeOrderLineShipment',
  options: storeOrderLineShipmentOptions,
  backendEntityIDField: 'ticketNumber'
} as CrudStore;

const storeOrderLinesCancelled = {
  permissionName: 'StoreUser',
  requestUrl: '/storeOrderLinesCancelled',
  store: 'storeOrderLinesCancelled',
  backendEntityIDField: 'ticketNumber'
} as CrudStore;

const report = {
  permissionName: 'OrderReport',
  requestUrl: '/report',
  store: 'report',
  options: reportOptions
} as CrudStore;

const invoiceSummary = {
  permissionName: 'InvoiceSummary',
  requestUrl: '/invoice-summary',
  store: 'invoiceSummary',
  options: invoiceSummaryOptions
} as CrudStore;

const entities = [
  accesslog,
  appSetting,
  ban,
  client,
  collection,
  company,
  configuration,
  contactPerson,
  country,
  culture,
  currency,
  domain,
  domainUser,
  eventlog,
  exactInstance,
  externalApiUser,
  externalInvoice,
  fabric,
  fabricOrder,
  fabricOrderLine,
  fabricStockReport,
  finish,
  finishType,
  glAccount,
  hemaPendingProject,
  interiorDecorator,
  interiorDecoratorFabric,
  interiorDecoratorOrder,
  internalInvoice,
  invalidFinishCombination,
  invoiceSummary,
  language,
  linkDomainDeliveryPrice,
  linkDomainProductGroup,
  linkDomainProductGroupFinish,
  linkPriceListItem,
  linkReasonStockCorrectionDomain,
  linkStoreCollection,
  option,
  order,
  orderDraft,
  orderLine,
  orderLinePrice,
  orderLineStatus,
  orderPickList,
  storeOrderLine,
  storeOrderLinesCancelled,
  storeOrderLineShipment,
  penalty,
  permission,
  parcelType,
  priceListItem,
  priceListItemPrice,
  priceListMatrix,
  printer,
  printerClient,
  printTemplate,
  product,
  productGroup,
  productType,
  productionPlanning,
  productionPlanningSelection,
  productionPlanningSeries,
  reasonStockCorrection,
  queuedKwantumOrder,
  report,
  returnCause,
  returnReason,
  returnReasonCategory,
  role,
  shipment,
  shipmentListType,
  special,
  standardUser,
  stockCorrection,
  stock,
  stockLocation,
  store,
  storeAttribute,
  storeFabric,
  storeType,
  storeUser,
  supplier,
  templateImage,
  translation,
  transportcompany,
  transportorder,
  transportroute,
  truck,
  unit,
  vatType,
  vatTypeRate,
  workshop,
  yarn
];

export default entities;
